<template>
  <div class="hello" :class="{'menuOpen': menuOpen}">
    <div class="wrapper header" id="header">
      <div class="inner">
        <div class="topLeft">
          <img src="../assets/top2.png">
        </div>
        <div class="hamburger-menu" @click="toggleMenu($event)">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="banner"></div>
    <div class="helloC">
      <div class="drawer-menu" :class="{'drawer-menu-open': menuOpen}" @click.stop>
        <div class="drawer-menu-header">
          <div class="drawer-close" @click="toggleMenu">×</div>
        </div>
        <ul class="drawer-menu-items">
          <li @click="zero()" :class="{'drawer-active': currentPage === 'home'}">
            <a class="drawer-menu-link">首页</a>
          </li>
          <li @click="One()" :class="{'drawer-active': currentPage === 'survey'}">
            <a class="drawer-menu-link">集团概况</a>
          </li>
          <li @click="Two()" :class="{'drawer-active': currentPage === 'state'}">
            <a class="drawer-menu-link">集团动态</a>
          </li>
          <li @click="Three()" :class="{'drawer-active': currentPage === 'party'}">
            <a class="drawer-menu-link">党建之家</a>
          </li>
          <li @click="five()" :class="{'drawer-active': currentPage === 'culture'}">
            <a class="drawer-menu-link">企业文化</a>
          </li>
          <li @click="six()" :class="{'drawer-active': currentPage === 'relation'}">
            <a class="drawer-menu-link">联系我们</a>
          </li>
        </ul>
      </div>
      <div class="drawer-overlay" v-if="menuOpen" @click="closeMenu"></div>
      <div class="bannerChange">
        <div class="bodyAll">
          <ul>
            <li class="first" :class="{'active': currentPage === 'home'}" @click="zero()">
              <a class="menu-link">
                首&nbsp;&nbsp;&nbsp;&nbsp;页
              </a>
            </li>
            <li class="second" :class="{'active': currentPage === 'survey'}" @click="One()">
              <a class="menu-link">
              集团概况
              </a>
            </li>
            <li class="third" :class="{'active': currentPage === 'state'}" @click="Two()">
              <a class="menu-link">
              集团动态
              </a>
            </li>
            <li class="fourth" :class="{'active': currentPage === 'party'}" @click="Three()">
              <a class="menu-link">
              党建之家
              </a>
            </li>
            <li class="five" :class="{'active': currentPage === 'culture'}" @click="five()">
              <a class="menu-link">
              企业文化
              </a>
            </li>
            <li class="six" :class="{'active': currentPage === 'relation'}" @click="six()">
              <a class="menu-link i9">
              联系我们
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main1">
      <div class="conta">
        <div class="mc">
            <div class="post">
              <div class="con">
                <div class="news_title"><router-link :to="{path:'/bidsNew', query:{id:this.ALLid,title:'集团要闻'}}">{{titles}}</router-link></div>
                <div class="news_text">
                  &nbsp;&nbsp;&nbsp;&nbsp;{{content}}...<router-link :to="{path:'/bidsNew', query:{id:this.ALLid,title:'集团要闻'}}"><span>[详细]</span></router-link>
                </div>
              </div>
            </div>
        </div>
        <div class="ml">
          <div class="post-11">
            <swiper
              :style="{ width: '100%', height: '100%' }"
              ref="mySwiper"
              :options="swiperOptions"
              v-if="showSwiper"
            >
              <swiper-slide v-for="(item, i) in picList" :key="i">
                <div class="swiper-item">
                  <div class="swiper-item-picture">
                    <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'图片新闻'}}">
                      <img class="imgStyle" :src="url+item.relatedPictures" alt="" />
                      <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'图片新闻'}}"><div class="bottomWord">{{item.articleTitle}}</div></router-link>
                    </router-link>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
          <div class="post-13">
            <div class="tt">
              <h3 class="tit">
                <span class="title">新闻中心</span>
              </h3>
              <div class="more_btn">
                <span class="more_text">
                  <router-link :to="{path:'/State'}"><img src="../assets/gd.png"></router-link>
                </span>
              </div>
            </div>
            <div class="contain">
              <ul>
                <li v-for="(item,index) in listWord" :key="index" @click="goToAbout(item.id)"><a>{{item.articleTitle}}</a><span>{{item.releaseDate}}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main3W">
      <div class="main3">
          <div class="matter">
            <div class="sudy-tab">
              <ul class="tab-menu">
                <li :class="{ select: isActive === 0 }" @click="switchTab(0, '通知公告')">通知公告</li>
                <li :class="{ select: isActive === 1 }" @click="switchTab(1, '党务公开')">党务公开</li>
                <li :class="{ select: isActive === 2 }" @click="switchTab(2, '专题活动')">专题活动</li>
              </ul>
            </div>
            <div class="listT" v-show="isActive === 0">
              <ul>
                <li v-for="(item, index) in contactL" :key="index" @click="getabout(item.id)">
                  <a>{{item.articleTitle}}</a>
                  <span>{{item.releaseDate}}</span>
                </li>
              </ul>
            </div>
            <div class="listT" v-show="isActive === 1">
              <ul>
                <li v-for="(item, index) in partyList" :key="index" @click="getabout(item.id)">
                  <a>{{item.articleTitle}}</a>
                  <span>{{item.releaseDate}}</span>
                </li>
              </ul>
            </div>
            <div class="listT" v-show="isActive === 2">
              <ul>
                <li v-for="(item, index) in activList" :key="index" @click="getabout(item.id)">
                  <a>{{item.articleTitle}}</a>
                  <span>{{item.releaseDate}}</span>
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>
    <div class="main6">
        <div class="ring">
            <div class="ringtt">
              <div class="ring_title">集团成员</div>
            </div>
            <div class="menber">
              <div class="all">
                <div class="news_box clearfix">
                  <div class="news_img">
                    <img src="../assets/one.jpeg">
                  </div>
                  <div class="news_wz">
                    <div class="news_con">
                      <div class="news_titles">临港建设</div>
                      <div class="news_texts">
                        扬州市临港建设发展有限公司成立于2012-02-03，法定代表人为傅延生，企业地址位于维扬路28号，所属行业为房屋建筑业
                      </div>
                    </div>
                  </div>
                </div>

                <div class="news_box clearfix">
                  <div class="news_img">
                    <img src="../assets/two.jpeg">
                  </div>
                  <div class="news_wz">
                    <div class="news_con">
                      <div class="news_titles">绿建公司</div>
                      <div class="news_texts">
                        扬州绿投建设工程有限公司成立于2020-05-21，法定代表人为卞正文，企业地址位于扬州市开发区八里镇金山路123号1幢，所属行业为房屋建筑业
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menber">
              <div class="all">
                <div class="news_box clearfix">
                  <div class="news_img">
                    <img src="../assets/three.jpeg">
                  </div>
                  <div class="news_wz">
                    <div class="news_con">
                      <div class="news_titles">绿投地产</div>
                      <div class="news_texts">
                        扬州绿投地产开发有限公司，注册资金5000万元，成立于2022年01月20日，注册地位于扬州市经济开发区维扬路108号，法定代表人为丁振宇。经营范围包括房地产开发经营，建设工程施工，物业管理等
                      </div>
                    </div>
                  </div>
                </div>

                <div class="news_box clearfix">
                  <div class="news_img">
                    <img src="../assets/heng.jpg">
                  </div>
                  <div class="news_wz">
                    <div class="news_con">
                      <div class="news_titles">恒运建设</div>
                      <div class="news_texts">
                        扬州恒运建设发展有限公司成立于2010年9月，注册资本为9.4亿元人民币。公司主营业务包含非居住房地产租赁、产业投资、光伏投资建设等。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="main7">
        <div class="fact">
          <div class="quclick">
            <div class="quick-link">
              <a href="http://www.yzltjt.com:89" class="quick-button">
                <div class="quick-icon">
                  <i class="quick-icon-business"></i>
                </div>
                <div class="quick-text">内部业务管理系统</div>
              </a>
            </div>
            <div class="quick-link">
              <a href="http://www.yzltjt.com:84/LoginTwo" class="quick-button">
                <div class="quick-icon">
                  <i class="quick-icon-supplier"></i>
                </div>
                <div class="quick-text">供应商管理平台</div>
              </a>
            </div>
            <div class="quick-link">
              <router-link :to="{path:'/Relation'}" class="quick-button">
                <div class="quick-icon">
                  <i class="quick-icon-message"></i>
                </div>
                <div class="quick-text">寄语绿投</div>
              </router-link>
            </div>
          </div>
        </div>
    </div>
    <div class="main4"></div>
    <FooterHtm/>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css"
import Home from './Home'
import FooterHtm from './FooterHtm'
import Survey from './Survey'
import State from './State'
import Party from './Party'
import Culture from './Culture'
import Relation from './Relation'
import $http from "../ApI/request";
export default {
  name: 'HelloWorld',
  components: {
    Home,
    FooterHtm,
    Survey,
    State,
    Party,
    Culture,
    Relation,
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      isActive: 0,
      picList: [],
      listWord: [],
      titles:'',
      content:'',
      contentL:'',
      ALLid:'',
      contactL: [],
      partyList:[],
      activList: [],
      url: 'http://www.yzltjt.com/ri-richuang/sys/common/static/',
      menuOpen: false,
      currentPage: 'home',
      swiperOptions: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          clickableClass : 'my-pagination-clickable',
        },
      },
    }
  },
  computed: {
    showSwiper(){
      return this.picList.length;
    }
  },
  mounted() {
    this.currentPage = 'home';
    
    document.addEventListener('click', this.handleOutsideClick);
    
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'图片新闻',
        column: 'releaseDate',
        order: 'desc',
      }
    }).then(res=>{
      this.picList = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'集团要闻',
        column: 'releaseDate,createTime',
        order: 'desc'
      }
    }).then(res=>{
      this.listWord = res.data.result.records
      this.titles = res.data.result.records[0].articleTitle
      let str = res.data.result.records[0].articleConten.replace(/<\/?.+?\/?>|\r|\n|[&nbsp;]/g,'').slice(0,150);
      str=str.replaceAll("ldquo",'“');
      str=str.replaceAll("rdquo",'”');
      str=str.replaceAll("middot",'·');
      str=str.replaceAll("mdahmdah",'——');
      this.content = str;
      this.ALLid = res.data.result.records[0].id
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'通知公告',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.contactL = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'党务公开',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.partyList = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'专题活动',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      console.log(res)
      this.activList = res.data.result.records
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods:{
    closeMenu() {
      this.menuOpen = false;
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
    },
    handleOutsideClick(event) {
      const drawer = document.querySelector('.drawer-menu');
      const hamburger = document.querySelector('.hamburger-menu');
      
      if (this.menuOpen && 
          drawer && 
          !drawer.contains(event.target) && 
          hamburger && 
          !hamburger.contains(event.target)) {
        this.closeMenu();
      }
    },
    toggleMenu(event) {
      if (event) {
        event.stopPropagation();
      }
      this.menuOpen = !this.menuOpen;
      
      if (this.menuOpen) {
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          document.addEventListener('click', this.handleOutsideClick);
        }, 10);
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.body.style.position = '';
        document.body.style.height = '';
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    goToAbout(e){
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
      this.$router.push({ path:'/bidsNew', query:{id:e,title:'集团要闻'}})
    },
    getabout(id) {
      const titles = {
        0: '通知公告',
        1: '党务公开',
        2: '专题活动'
      };
      
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
      
      this.$router.push({
        path: '/bidsNew',
        query: {
          id: id,
          title: titles[this.isActive]
        }
      });
    },
    zero(){
      this.currentPage = 'home';
      this.$router.push({
        name:'HelloWorld',
      })
    },
    One(){
      this.currentPage = 'survey';
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
    },
    Two(){
      this.currentPage = 'state';
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
    },
    Three(){
      this.currentPage = 'party';
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
    },
    five(){
      this.currentPage = 'culture';
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
    },
    six() {
      this.currentPage = 'relation';
      this.$router.push({
        name: 'Relation',
        params: {
          num: 1
        }
      });
    },
    switchTab(index, type) {
      this.isActive = index;
      this.loadTabData(type);
    },
    loadTabData(type) {
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list', {
        params: {
          articleType: type,
          column: 'releaseDate',
          order: 'desc'
        }
      }).then(res => {
        if (res.data && res.data.result && res.data.result.records) {
          const records = res.data.result.records;
          switch(type) {
            case '通知公告':
              this.contactL = records;
              break;
            case '党务公开':
              this.partyList = records;
              break;
            case '专题活动':
              this.activList = records;
              break;
          }
        }
      }).catch(err => {
        console.error('加载数据失败:', err);
      });
    },
  },
  created() {
    this.loadTabData('通知公告');
    this.loadTabData('党务公开');
    this.loadTabData('专题活动');
  }
}
</script>

<style scoped>
.hello {
  height: 100%;
  width: 100%;
  cursor: default;
  overflow-x: hidden;
  max-width: 100%;
  position: relative;
}

.wrapper {
  position: relative;
}

.clearfix {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
}

.clearfix:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.banner {
  background: linear-gradient(to right, #0a3d82, #1e5dbd, #0a3d82);
  width: 100%;
  height: 160px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 0;
}

#header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}

#header .inner {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  height: 132px;
  position: relative;
}

.topLeft {
  float: left;
  padding-top: 25px;
  padding-left: 60px;
}

.topLeft img {
  height: 54px;
  transition: transform 0.3s ease;
}

.topLeft img:hover {
  transform: scale(1.05);
}

.helloC {
  position: relative;
  z-index: 5;
}

.navChange {
  width: 100%;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  z-index: 1000;
}

.bodyAll {
  width: 100%;
  max-width: 1300px;
  height: 70px;
  margin: -20px auto;
  background: linear-gradient(to right, #0a3d82, #1e5dbd, #0a3d82);
  border-radius: 6px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.bodyAll ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  flex-wrap: wrap;
}

.post-11 {
  width: 48%;
  height: 350px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.swiper-item {
  width: 100%;
  height: 100%;
}

.swiper-item-picture {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.swiper-item-picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bottomWord {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50px;
  line-height: 50px;
  padding: 0 15px;
  font-size: 18px;
  background: rgba(12, 77, 162, 0.8);
  z-index: 9;
  font-weight: 700;
  text-align: left;
  color: rgb(255, 255, 255);
  width: 100%;
  transition: height 0.3s ease;
}

.swiper-item-picture:hover .bottomWord {
  height: 60px;
}

.main1{
  padding-bottom: 32px;
  margin-top: 50px;
  position: relative;
  z-index: 1;
  overflow: visible;
  height: auto;
  min-height: 580px;
  margin-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.main1 .conta{
  padding: 10px 30px 30px;
  background: white;
  width: 100%;
  max-width: 1370px;
  height: auto;
  position: relative;
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.main1 .mc{
  background: white;
  position: relative;
  top: 0;
  padding: 20px 30px;
  width: calc(100% - 20px);
  height: auto;
  min-height: 160px;
  margin: 10px auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  box-sizing: border-box;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main1 .mc:hover {
  transform: translateY(-5px);
}

.main1 .ml{
  width: calc(100% - 20px);
  display: flex;
  justify-content: space-between;
  margin: 10px auto 0;
  padding-top: 10px;
  height: auto;
}

.main3W{
  height: auto;
  margin-top: 0;
  position: relative;
  z-index: 0;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.main3{
  background: linear-gradient(rgba(12, 77, 162, 0.03), rgba(12, 77, 162, 0.08));
  padding-bottom: 30px;
  width: 100%;
  height: auto;
  min-height: 430px;
}

.post{
  width: auto;
  height: auto;
  background: none;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}

.con{
  width: 95%;
  max-width: 1200px;
  padding: 0;
  margin: 0 auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.matter{
  padding: 20px 50px 50px;
  background: white;
  width: 100%;
  max-width: 1300px;
  height: auto;
  min-height: 379px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.all {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  padding: 0;
  margin: 20px auto;
  max-width: 1200px;
  width: 100%;
}

.sudy-tab{
  position: relative;
  margin-bottom: 20px;
}

.tab-menu{
  height: 60px;
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  text-align: center;
  padding: 0;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.tab-menu li{
  display: inline-block;
  height: 50px;
  line-height: 30px;
  float: none;
  font-size: 23px;
  color: #969696;
  padding: 0 20px;
  margin: 0 30px;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  text-align: center;
  font-weight: bolder;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}

.tab-menu li:hover {
  color: #1e5dbd;
}

.select{
  border-bottom: 6px solid #1e5dbd;
  height: 38px !important;
  color: #0c4da2 !important;
}

.news_title {
  color: #0c4da2;
  font-size: 26px;
  line-height: 48px;
  font-weight: bold;
  padding-bottom: 6px;
  position: relative;
  transition: color 0.3s ease;
}

.news_title a {
  color: inherit;
  text-decoration: none;
  display: inline-block;
}

.news_title a:hover {
  color: #1e5dbd;
}

.news_title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background: #1e5dbd;
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: left;
}

.news_title:hover::after {
  transform: scaleX(1);
}

.news_text {
  font-size: 18px;
  line-height: 1.8;
  color: #4a4a4a;
  font-weight: normal;
  letter-spacing: 0.5px;
  text-align: justify;
}

.news_text span {
  font-size: 15px;
  color: #1e5dbd;
  font-weight: bold;
  margin-left: 8px;
  position: relative;
  transition: all 0.3s ease;
}

.news_text span:hover {
  color: #76b6ff;
  padding-left: 5px;
}

.news_text span::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: currentColor;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.news_text span:hover::before {
  transform: scaleX(1);
}

.post-13{
  width: 48%;
  height: 350px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  box-sizing: border-box;
  float: none;
}

.tt{
  height: 64px;
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  padding: 0 5px;
}

.tit{
  display: block;
  float: left;
  font-size: 18px;
  font-weight: bolder;
  border-bottom: 5px solid #1e5dbd;
  padding-bottom: 10px;
}

.title{
  display: inline-block;
  margin-right: 0px;
  font-size: 23px;
  color: #0c4da2;
  cursor: pointer;
}

.more_btn{
  display: block;
  float: right;
  height: 20px;
  margin-top: 20px;
  line-height: 20px;
}

.more_text{
  font-size: 13px;
  cursor: pointer;
}

.contain {
  padding: 8px 10px;
  margin: 0 auto;
  overflow: hidden;
}

.contain ul {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 250px;
  overflow-y: auto;
}

.contain ul li {
  padding: 8px 0;
  margin: 0;
  border-bottom: 1px dashed rgba(12, 77, 162, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  display: table;
  table-layout: fixed;
}

.contain ul li:hover {
  background-color: rgba(30, 93, 189, 0.05);
  padding-left: 5px;
}

.contain ul li a {
  display: table-cell;
  width: 70%;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: FangSong, "仿宋", FangSong_GB2312, STFangsong, "华文仿宋", serif;
  padding-left: 5px;
}

.contain ul li span {
  display: table-cell;
  width: 30%;
  font-size: 14px;
  color: #666;
  text-align: right;
  padding-right: 5px;
  font-family: 仿宋;
}

.listT {
  height: 0px;
  overflow: visible;
  cursor: pointer;
}

.listT ul {
  margin-block-start: 0.5em;
  margin-block-end: 1em;
  overflow-y: auto;
  height: 280px;
  scrollbar-width: thin;
  scrollbar-color: #1e5dbd #f1f1f1;
  padding: 0 15px;
}

.listT ul::-webkit-scrollbar {
  width: 6px;
}

.listT ul::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.listT ul::-webkit-scrollbar-thumb {
  background: #1e5dbd;
  border-radius: 10px;
}

.listT ul li{
  border-bottom: 1px dashed rgba(12, 77, 162, 0.2);
  line-height: 40px;
  padding-left: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.listT ul li:hover {
  background-color: rgba(30, 93, 189, 0.05);
  padding-left: 15px;
}

.listT ul li a{
  flex: 1;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  font-family: FangSong, "仿宋", FangSong_GB2312, STFangsong, "华文仿宋", serif;
}

.listT ul li span{
  float: right;
  margin-left: 2px;
  color: #666;
  font-size: 14px;
  font-family: 仿宋;
}

.menber {
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px;
}

.news_box {
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.news_box:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.news_img {
  width: 200px;
  height: 160px;
  border-radius: 8px 0 0 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.news_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.news_box:hover .news_img img {
  transform: scale(1.05);
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.imgStyle {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news_wz {
  flex: 1;
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.news_con {
  line-height: 1.5;
}

.news_titles {
  font-size: 22px;
  color: #0c4da2;
  font-weight: bold;
  margin-bottom: 10px;
  position: relative;
  padding-bottom: 10px;
}

.news_titles::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background: #1e5dbd;
  transition: width 0.3s ease;
}

.news_box:hover .news_titles::after {
  width: 80px;
}

.news_texts {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main6{
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding: 0px 0px 40px;
  height: auto;
  min-height: 700px;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.ring{
  width: 100%;
  margin: 0 auto;
}

.ringtt{
  margin: 20px auto;
  font-weight: 600;
  text-align: center;
}

.ring_title{
  display: inline-block;
  margin-top: 30px;
  color: #0c4da2;
  cursor: pointer;
  padding-bottom: 15px;
  font-size: 26px;
  border-bottom: 3px solid #1e5dbd;
}

.ring .more_btn{
  float: none;
  margin-left: 20px;
}

.main7{
  width: 100%;
  padding: 10px 0;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.fact{
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.quclick{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding: 20px 0;
}

.quick-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: #0c4da2;
  transition: all 0.3s ease;
}

.quick-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: linear-gradient(135deg, #f5f7ff 0%, #e8f0ff 100%);
  transition: all 0.3s ease;
}

.quick-link:hover .quick-icon {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(12, 77, 162, 0.15);
  background: linear-gradient(135deg, #e8f0ff 0%, #d1e3ff 100%);
}

.quick-text {
  font-size: 16px;
  font-weight: 600;
  color: #0c4da2;
  margin-top: 10px;
  text-align: center;
}

.quick-icon-business,
.quick-icon-supplier,
.quick-icon-message {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.quick-icon-business {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%230c4da2'%3E%3Cpath d='M20 6h-3V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9 4h6v2H9V4zm11 15H4V8h16v11z'/%3E%3Cpath d='M12 9h-1v1h1v4h-1v1h3v-1h-1z'/%3E%3C/svg%3E");
}

.quick-icon-supplier {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%230c4da2'%3E%3Cpath d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z'/%3E%3C/svg%3E");
}

.quick-icon-message {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%230c4da2'%3E%3Cpath d='M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z'/%3E%3Cpath d='M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z'/%3E%3C/svg%3E");
}

@media screen and (max-width: 1400px) {
  .main1 .conta {
    max-width: 95%;
  }
  .matter {
    max-width: 95%;
    padding: 20px 30px 30px;
    margin-left: auto;
    margin-right: auto;
  }
  .bodyAll, .ring, .fact {
    max-width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (max-width: 992px) {
  .main1 .ml {
    flex-direction: column;
  }
  .post-11 {
    width: 100%;
    margin-bottom: 20px;
  }
  .post-13 {
    width: 100%;
  }
  .all {
    grid-template-columns: 1fr;
  }
  .tab-menu li {
    font-size: 18px;
    padding: 0 10px;
    margin: 0 15px;
  }
  .news_box {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 768px) {
  .banner {
    height: 120px;
  }
  #header .inner {
    height: 100px;
  }
  .topLeft img {
    height: 40px;
  }
  .topLeft {
    padding-top: 15px;
    padding-left: 60px;
  }
  .bodyAll {
    height: auto;
    padding: 10px 0;
  }
  .bodyAll ul {
    flex-wrap: wrap;
    padding: 10px 0;
  }
  .bodyAll li {
    width: 33.33%;
    text-align: center;
    margin: 5px 0;
  }
  .matter {
    padding: 20px 15px 30px;
  }
  .tab-menu {
    height: auto;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .tab-menu li {
    font-size: 16px;
    padding: 0 5px;
    margin: 0 10px 10px;
  }
  .news_title {
    font-size: 20px;
    line-height: 28px;
  }
  .news_text {
    font-size: 14px;
  }
  .news_titles {
    font-size: 18px;
  }
  .news_texts {
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }
  .news_box {
    margin-bottom: 15px;
  }
  .news_img {
    width: 150px;
    height: 120px;
  }
  .swiper-item-picture img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  .hamburger-menu {
    display: flex;
    z-index: 1010;
  }
  .bannerChange .bodyAll {
    display: none;
  }
  .drawer-menu {
    width: 240px;
  }
  .drawer-menu-header {
    height: 60px;
  }
  .drawer-menu-link {
    padding: 12px 15px;
    font-size: 15px;
  }
  .drawer-menu, .drawer-overlay {
    height: 100%;
    height: -webkit-fill-available;
  }
  .hello, .main1, .main3, .main6, .main7, 
  .main1 .conta, .matter, .bodyAll, .ring, .fact {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
}

@media screen and (max-width: 576px) {
  .banner {
    height: 80px;
  }
  .topLeft img {
    height: 32px;
  }
  #header .inner {
    height: 70px;
  }
  .bodyAll {
    margin-top: 0;
  }
  .bodyAll li {
    width: 50%;
  }
  .main1 {
    margin-top: 70px;
  }
  .main1 .mc {
    padding: 15px;
    min-height: auto;
  }
  .post-11 {
    height: 250px;
  }
  .bottomWord {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  .news_box {
    flex-direction: column;
  }
  .news_img {
    width: 100%;
    height: 180px;
    border-radius: 8px 8px 0 0;
  }
  .swiper-item-picture img {
    height: 100%;
  }
  .news_wz {
    padding: 15px;
  }
  .main1 .ml {
    flex-direction: column;
  }
  .post-11, .post-13 {
    width: 100%;
    margin-bottom: 20px;
  }
  .all {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .ringtt {
    margin: 10px auto;
  }
  .ring_title {
    font-size: 20px;
    margin-top: 15px;
  }
  .topLeft {
    padding-left: 50px;
  }
  .hamburger-menu {
    top: 20px;
    left: 15px;
  }
  
  .drawer-menu {
    width: 230px;
  }
  
  body, html {
    width: 100%;
    overflow-x: hidden;
    max-width: 100%;
  }
}

@media screen and (max-width: 375px) {
  .drawer-menu {
    width: 220px;
  }
}

.bannerChange {
  width: 100%;
  position: relative;
}

.first,.second,.third,.fourth,.five,.six {
  border: none;
  background: none;
  letter-spacing: 2px;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  color: rgb(255, 255, 255);
  display: block;
  float: left;
}

.menu-link {
  display: inline-block;
  padding: 0 60px;
  line-height: 65px;
  margin-top: -15px;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 800;
  background: url(../assets/sx.png) no-repeat right center;
  position: relative;
  text-decoration: none;
}

.menu-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background-color: #76b6ff;
  transform: translateX(-50%);
  transition: width 0.3s ease;
}

.menu-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  text-decoration: none;
  line-height: 65px;
  margin-top: -15px;
  color: #eee;
  cursor: pointer;
}

.menu-link:hover::after {
  width: 70%;
}

.listT {
  height: 280px;
  overflow: auto;
}

.listT ul {
  list-style: none;
  padding: 0 15px;
  margin: 0;
}

.listT ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px dashed rgba(12, 77, 162, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.listT ul li:hover {
  background-color: rgba(30, 93, 189, 0.05);
  padding-left: 15px;
}

.listT ul li a {
  flex: 1;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  font-family: FangSong, "仿宋", FangSong_GB2312, STFangsong, "华文仿宋", serif;
}

.listT ul li span {
  color: #666;
  font-size: 14px;
}

.post-13 {
  width: 48%;
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.tt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
  padding: 15px 20px;
}

.tit {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #0c4da2;
}

.title {
  position: relative;
  padding-left: 15px;
}

.title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 20px;
  background: #1e5dbd;
  border-radius: 3px;
}

.contain {
  padding: 10px 15px;
  margin: 0 auto;
  overflow: hidden;
}

.contain ul {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 250px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #1e5dbd #f1f1f1;
}

.contain ul::-webkit-scrollbar {
  width: 6px;
}

.contain ul::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.contain ul::-webkit-scrollbar-thumb {
  background: #1e5dbd;
  border-radius: 10px;
}

.contain ul li {
  padding: 8px 0;
  margin: 0;
  border-bottom: 1px dashed rgba(12, 77, 162, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  display: table;
  table-layout: fixed;
}

.contain ul li:hover {
  background-color: rgba(30, 93, 189, 0.05);
  padding-left: 5px;
}

.contain ul li a {
  display: table-cell;
  width: 70%;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: FangSong, "仿宋", FangSong_GB2312, STFangsong, "华文仿宋", serif;
}

.contain ul li span {
  display: table-cell;
  width: 30%;
  font-size: 14px;
  color: #666;
  text-align: right;
  font-family: 仿宋;
}

@media screen and (max-width: 992px) {
  .menu-link {
    padding: 0 30px;
    font-size: 16px;
  }
}

@media screen and (max-width: 768px) {
  .menu-link {
    padding: 0 20px;
    font-size: 14px;
    background: none;
  }
  .first,.second,.third,.fourth,.five,.six {
    font-size: 14px;
  }
  .post-13 {
    width: 100%;
    height: auto;
    min-height: 350px;
  }
  .listT {
    height: 250px;
  }
  .contain {
    height: 250px;
  }
  .listT ul li a, 
  .contain ul li a {
    font-size: 14px;
  }
}

@media screen and (max-width: 576px) {
  .bannerChange {
    margin-top: 20px;
  }
  .bodyAll {
    height: auto;
    border-radius: 0;
  }
  .bodyAll ul {
    flex-direction: column;
    padding: 10px 0;
  }
  .bodyAll li {
    width: 100%;
    margin: 5px 0;
  }
  .first,.second,.third,.fourth,.five,.six {
    width: 100%;
    float: none;
    height: 40px;
  }
  .menu-link {
    width: 100%;
    text-align: center;
    line-height: 40px;
    margin-top: 0;
    padding: 0;
  }
  .menu-link:hover {
    line-height: 40px;
    margin-top: 0;
  }
  .listT {
    height: 200px;
  }
  .contain {
    height: 200px;
  }
  .listT ul li, 
  .contain ul li {
    padding: 8px 5px;
  }
  .tt {
    padding: 10px 15px;
  }
  .tit {
    font-size: 16px;
  }
  .title::before {
    height: 16px;
  }
  .tab-menu {
    justify-content: space-between;
  }
  .tab-menu li {
    margin: 0 5px 10px;
    padding: 0;
    font-size: 14px;
  }
}

.hamburger-menu {
  display: none;
  position: absolute;
  left: 20px;
  top: 25px;
  width: 30px;
  height: 24px;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  z-index: 1001;
}

.hamburger-menu span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.drawer-menu {
  position: fixed;
  top: 0;
  left: -300px;
  width: 260px;
  height: 100vh;
  background: linear-gradient(135deg, #0a3d82, #1e5dbd);
  z-index: 1001;
  transition: left 0.3s ease;
  overflow-y: auto;
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.2);
}

.drawer-menu-open {
  left: 0;
}

.drawer-menu-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.drawer-logo {
  display: none;
}

.drawer-close {
  font-size: 30px;
  color: #fff;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s ease;
}

.drawer-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.drawer-menu-items {
  list-style: none;
  padding: 20px 0;
  margin: 0;
}

.drawer-menu-items li {
  padding: 0;
  margin: 10px 0;
}

.drawer-menu-items li {
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.drawer-menu-items li:last-child {
  border-bottom: none;
}

.drawer-menu-link {
  display: block;
  padding: 15px 20px;
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  border-right: 4px solid transparent;
  border-left: none;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 1px;
  position: relative;
}

.drawer-menu-link:hover, .drawer-menu-link:active {
  background: rgba(255, 255, 255, 0.1);
  border-right: 4px solid #76b6ff;
  padding-right: 25px;
  padding-left: 20px;
}

.drawer-menu-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 20px;
  width: 0;
  height: 2px;
  background: #76b6ff;
  transition: width 0.3s ease;
}

.drawer-menu-link:hover::after {
  width: calc(100% - 40px);
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

@media screen and (max-width: 768px) {
  .hamburger-menu {
    display: flex;
  }
  
  .menuOpen .hamburger-menu span:nth-child(1) {
    transform: translateY(10px) rotate(45deg);
  }
  
  .menuOpen .hamburger-menu span:nth-child(2) {
    opacity: 0;
  }
  
  .menuOpen .hamburger-menu span:nth-child(3) {
    transform: translateY(-10px) rotate(-45deg);
  }
}

@media screen and (max-width: 576px) {
  .hamburger-menu {
    top: 20px;
    left: 15px;
  }
  
  .drawer-menu {
    width: 250px;
  }
  
  .drawer-menu-link {
    padding: 12px 15px;
    font-size: 15px;
  }
  
  .drawer-close {
    width: 35px;
    height: 35px;
  }
}

.drawer-menu-items .drawer-active .drawer-menu-link {
  background: rgba(255, 255, 255, 0.1);
  border-right: 4px solid #76b6ff;
  padding-right: 25px;
  padding-left: 20px;
  color: #76b6ff;
}

.active .menu-link {
  color: #76b6ff !important;
  border-bottom: 3px solid #76b6ff;
}

.first.active .menu-link {
  color: #76b6ff;
  border-bottom: 3px solid #76b6ff;
}

.second .menu-link, .third .menu-link, .fourth .menu-link, .five .menu-link, .six .menu-link {
  border-bottom: none;
}

.active-link {
  color: #76b6ff !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue